//
//
//
//

import AV from "leancloud-storage";
import MainLayout from "./pages/layouts/Main";
import LibLayout from "./pages/layouts/Lib";
import EduLayout from "./pages/layouts/Edu";
import JmLayout from "./pages/layouts/Jm";
import KebenLayout from "./pages/layouts/Keben";

import { mapGetters } from "vuex";

// 判断是否是pc
const checkPC = () => {
  let userAgentInfo = navigator.userAgent;
  let Agents = new Array(
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod"
  );
  let flag = true;

  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }

  return flag;
};

export default {
  name: "app",
  created() {
    let appId = this.$route.query.appId;
    let timestamp = parseInt(this.$route.query.timestamp);
    let sign = this.$route.query.sign;
    let randomString = this.$route.query.randomString;
    let userId = this.$route.query.userId;
    let action = this.$route.query.action;

    console.log(this.$route.query);

    // 第三方登录
    if (
      appId &&
      timestamp &&
      sign &&
      randomString &&
      userId &&
      action == "signIn"
    ) {
      AV.Cloud.run("getAuthDataByThirdParth", {
        appId,
        timestamp,
        sign,
        randomString,
        userId,
        action
      })
        .then(authData => {
          return AV.User.loginWithAuthData(authData, "h5");
        })
        .then(user => {
          this.$store.commit("logIn", user.toJSON());
          
          let query = Object.assign({}, this.$route.query);
          delete query.appId;
          delete query.timestamp;
          delete query.action;
          delete query.randomString;
          delete query.sign;
          delete query.userId;
          this.$router.replace({ query });
        });
    }
  },

  beforeCreate() {
    let domain = location.href.match(/\w+:\/\/([^\/]+)/)[1];

    switch (domain) {
      // case "csu.xcz.im":
      //   this.$store.commit("setLayout", "csu-layout");
      //   break;
      case "jm.xcz.im":
        this.$store.commit("setLayout", "jm-layout");
        break;
      // case 'edu.xcz.im':
      //   this.$store.commit('setLayout', 'edu-layout')
      //   break
      // case 'lib.xcz.im':
      //   this.$store.commit('setLayout', 'lib-layout')
      //   break
      // case "keben.xcz.im":
      //   this.$store.commit("setLayout", "keben-layout");
      //   break;
      default:
        this.$store.commit("setLayout", "main-layout");
        break;
    }

    // this.$store.commit('setLayout', 'main-layout')   // 测试后一定要注释

    this.$store.commit("setPc", checkPC());
  },

  computed: {
    ...mapGetters(["layout"])
  },
  components: {
    "main-layout": MainLayout, // 主页面
    "lib-layout": LibLayout, // lib.xcz.im 图书馆试用
    "edu-layout": EduLayout,
    "jm-layout": JmLayout,
    "keben-layout": KebenLayout
  }
};



// WEBPACK FOOTER //
// ./src/App.vue